import type { RefObject } from "react";
import { SlotsToClasses } from "@nextui-org/react";
import { cn } from "@/libs/utils/tailwind/cn";
import Header from "../Header";
import TrustBadges from "../TrustBadges";
import SearchServicesInput from "./SearchServicesInput";
import Carousel, { SwiperSlide } from "@/components/ui/Carousel";
import { prependCdnResourcesUrl } from "@/utils/network";

export default function HeroSection({ classNames, searchInputRef }: HeroSectionProps) {
  return (
    <section className={cn("relative sm:min-h-[756px] w-full flex flex-col", classNames?.base)}>
      <Header />

      <div className="absolute inset-x-0 bottom-0 top-[44px] sm:top-[86px]">
        <Carousel
          slidesPerView={1}
          showArrows={false}
          showDots={false}
          noSafePadding
          loop
          autoplay={{ delay: 6000, disableOnInteraction: false }}
          effect="fade"
          fadeEffect={{ crossFade: true }}
          className="h-full [&_.swiper]:h-full [&_.swiper-slide]:h-full [&_.swiper-wrapper]:h-full"
        >
          {[
            "/images/networx/homepage/hero-section/long-shot-men-working-roof-together.webp",
            "/images/networx/homepage/hero-section/tiler-working-renovation-apartment.webp",
            "/images/networx/homepage/hero-section/portrait-confident-young-carpenter.webp",
          ].map((image, key) => (
            <SwiperSlide key={key}>
              <img
                src={prependCdnResourcesUrl(image)}
                alt=""
                aria-hidden
                className="h-full w-full object-cover object-top"
              />
            </SwiperSlide>
          ))}
        </Carousel>
        <div className="absolute inset-0" />
      </div>

      {/* Hero Content */}
      <div className="relative z-10 flex flex-1 flex-col p-4 sm:p-5 py-8 sm:justify-center max-w-page mx-auto w-full items-center sm:items-start">
        <div className="flex flex-1 w-full max-w-[726px] flex-col gap-10 sm:flex-initial justify-center">
          <div className="flex flex-col gap-5 bg-black/50 rounded-2xl p-5 sm:px-14 sm:pt-10 sm:pb-12">

            {/* Headline */}
            <TrustBadges />
            <h1 className="font-semibold tracking-tight text-white text-[30px] sm:text-[56px] leading-tight mb-2 sm:mb-4">
              Find qualified <br />
              pros in your area
            </h1>
            <SearchServicesInput inputRef={searchInputRef} />
          </div>
        </div>
      </div>
    </section>
  );
}

interface HeroSectionProps {
  classNames?: SlotsToClasses<"base" | "container">;
  searchInputRef?: RefObject<HTMLInputElement>;
}